export const locale = {
    lang: 'vn',
    data: {
        'LOGIN': {
            'TITLE': 'Đăng nhập vào hệ thống',
            'USERNAME': 'Email hoặc tên đăng nhập',
            'PASSWORD': 'Mật khẩu',

            'VALIDATION': {
                'USERNAME': 'Vui lòng nhập email hoặc tên đăng nhập bắt buộc',
                'USERNAME_INVALID': 'Vui lòng nhập email hoặc tên đăng nhập chính xác',
                'PASSWORD': 'Vui lòng nhập mật khẩu bắt buộc'
            },

            'ACTION': {
                'LOGIN_PASSWORD': 'Đăng nhập',
                'LOGIN_GOOGLE': 'Đăng nhập qua Google',
                'REMEMBER_ME': 'Lưu đăng nhập',
                'FORGOT_PASSWORD': 'Quên mật khẩu?'
            },

            'OTHER': {
                'LOGIN_ERROR': 'Lỗi. Không đăng nhập được. Xin vui lòng thử lại sau.',
                'SEPERATOR': 'HOẶC'
            }
        },
        'DIALOG': {
            'HEADER': 'Quên mật khẩu?',
            'BODY': 'Liên hệ bộ phận hỗ trợ để được giúp đỡ',
            'OK_BTN_TEXT': 'OK',
        }
    }
};
